Vue.component("Focused", {
    props: ["isContentOpen", "settings"],
    template: `
        <transition name="fadein">
            <div id="focused-overlay" 
                v-if="isContentOpen && settings.enabled"
                @click="focusClicked"
                :style="getFocusedColor(getTaskType)">
            </div>
        </transition>
    `,
    methods: {
        focusClicked() {
            this.$emit("closeAllContent")
        },

        getFocusedColor(type) {
            switch(type) {
                case 'conference': 
                    return 'background: rgba(0, 0, 0, 0.7)';
            } 
        }
    },
    computed: {
        getTaskType() {
            let currentTask = this.$route.path.split(':')
            return touchKit.PageManager.getContent(currentTask[1]).type
        }
    }
})